<template>
  <b-collapse :key="componentKey" class="panel">
    <!-- <div slot="trigger" class="panel-heading">
      <strong>Contratti prodotti</strong>
    </div>-->
    <div class="panel-block">
      <table class="table is-fullwidth is-narrow">
        <!-- <thead>
          <tr>
            <th>Prodotto</th>
            <th>Qt.</th>
            <th>Seriale</th>
            <th></th>
          </tr>
        </thead>-->
        <tbody>
          <tr v-for="(contract, key) in formData" :key="contract.id">
            <td width="50">
              <b-field
                :message="showErrors[key]['order']"
                :type="showErrors[key]['order'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contract.order"
                  placeholder="N."
                  size="is-small"
                ></b-input>
              </b-field>
            </td>
            <td>
              <b-field
                :message="showErrors[key]['product']"
                :type="showErrors[key]['product'] ? 'is-danger' : ''"
              >
                <b-select
                  v-model="contract.product"
                  expanded
                  placeholder="Tipo prodotto"
                  size="is-small"
                >
                  <option
                    v-for="product in products.results"
                    :key="product.id"
                    :value="product.id"
                  >
                    {{ product.code }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td width="80">
              <b-field
                :message="showErrors[key]['amount']"
                :type="showErrors[key]['amount'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contract.amount"
                  type="number"
                  placeholder="qt"
                  size="is-small"
                ></b-input>
              </b-field>
            </td>
            <td>
              <b-field
                :message="showErrors[key]['serial']"
                :type="showErrors[key]['serial'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contract.serial"
                  placeholder="seriale"
                  size="is-small"
                ></b-input>
              </b-field>
            </td>
            <td>
              <button class="button is-small" @click="formData.splice(key, 1)">
                <b-icon icon="minus-circle" type="is-danger" />
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="9">
              <div class="buttons">
                <button
                  class="button is-success is-small"
                  @click="formData.push({ customer: customerId })"
                >
                  <b-icon icon="plus"></b-icon>
                  <span>Aggiungi contratto prodotto</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-small"
                  @click="reset"
                >
                  <b-icon icon="undo"></b-icon>
                  <span>Annulla</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-small is-primary"
                  type="submit"
                  @click="submit()"
                >
                  <b-icon icon="save"></b-icon>
                  <span>Salva</span>
                </button>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </b-collapse>
</template>

<script>
import cloneDeep from "lodash/cloneDeep"
import { get, call } from "vuex-pathify"

import dateHelpers from "@/mixins/dateHelpers"

export default {
  mixins: [dateHelpers],
  props: {
    customerId: {
      type: Number,
      required: true
    },
    productContracts: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      componentKey: 0, // used to force rerender
      formData: cloneDeep(this.productContracts),
      errors: []
    }
  },
  computed: {
    products: get("productTypes/productTypes"),
    formHasEdits() {
      return (
        JSON.stringify(this.productContracts) != JSON.stringify(this.formData)
      )
    },
    showErrors() {
      if (this.errors.length > 0) {
        return this.errors
      } else {
        let elements = []
        this.formData.forEach(() => {
          elements.push({})
        })
        return elements
      }
    }
  },
  mounted() {
    this.fetchProducts()
  },
  methods: {
    fetchProducts: call("productTypes/all"),
    submitAction: call("productContracts/update"),
    reset() {
      this.errors = []
      this.formData = cloneDeep(this.productContracts)
      this.componentKey += 1
    },
    async submit() {
      try {
        await this.submitAction({
          customerId: this.customerId,
          data: this.formData
        })
        this.reset()
        this.$toast.open({
          message: "Modificato con successo",
          type: "is-success"
        })
      } catch (response) {
        // show errors in form
        this.errors = response.data
      }
    }
  }
}
</script>
